import React from 'react';
import { useIntl } from 'react-intl';

import { Card } from '~/eds/src/components/Card/Card';
import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';
import { Icon } from '~/eds/src/components/Icon/Icon';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { api } from '~/redux/api/createApi';
import { PilotId } from '~/types/PilotId';

import { getFieldTypeLabel, getIconFromFieldType } from '../utils';

interface Props {
  id: PilotId;
}

export const FieldInfo = ({ id }: Props) => {
  // TODO: design specs to handle/retry async error
  const intl = useIntl();
  const { data = { results: [] }, isFetching: isLoading } =
    api.endpoints.getFields.useQuery({
      ids: [id],
      limit: 1,
    });

  const field = data.results[0];

  const loadingContent = {
    isLoading,
    shimmer: {
      height: 'height.m',
      width: '100%' as const,
    },
  };

  return (
    <Card mode="bordered" size="s" status="info" width="100%">
      <ContentContainer loadingContent={loadingContent}>
        {field && (
          <Layout align="center" spacing={2}>
            <Icon icon={getIconFromFieldType(field.type)} />
            <Layout direction="column">
              <Text>{field.label}</Text>
              <Text preset="help">{getFieldTypeLabel(field.type, intl)}</Text>
            </Layout>
          </Layout>
        )}
      </ContentContainer>
    </Card>
  );
};
